<template>
  <div>
    <v-dialog
      persistent
      v-if="isShowSelectMergeQuotation"
      v-model="isShowSelectMergeQuotation"
      fullscreen
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">合併報價單</span>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text>
          <ValidationObserver ref="mergeQuotation">
            <v-row>
              <v-col cols="3">
                <customer-autocomplete
                  refName="customerAutocomplete"
                  :fatherEditedCustomer="editedMergeQuotation"
                  :editedCustomerIndex="-1"
                  :customerName="'quotation_customer_number'"
                  @setCustomer="setCustomer"
                  :isAllTextFieldDisable="isAllTextFieldDisabled"
                />
              </v-col>
              <v-col cols="3">
                <v-text-field
                  label="客戶簡稱"
                  v-model="editedMergeQuotation.Customer.ShortName"
                  disabled
                ></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field
                  label="客戶全名"
                  v-model="editedMergeQuotation.Customer.FullName"
                  disabled
                ></v-text-field>
              </v-col>
              <v-col cols="3">
                <ValidationProvider
                  :name="$t('quotation_name')"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-autocomplete
                    v-model="editedMergeQuotation.QuotationType"
                    :items="allQuotationType"
                    item-text="Name"
                    item-value="Type"
                    :error-messages="errors[0]"
                    :disabled="isAllTextFieldDisabled"
                    :loading-text="$t('common_get_data')"
                    :no-data-text="$t('common_no_results')"
                    @change="getFilterQuotation"
                  >
                    <template v-slot:label>
                      <span class="red--text">
                        <strong>* </strong>
                      </span>
                      {{ $t('quotation_name') }}
                    </template>
                  </v-autocomplete>
                </ValidationProvider>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <ValidationProvider name="報價單清單" rules="required" v-slot="{ errors }">
                  <v-autocomplete
                    v-model="editedMergeQuotation.QuotationIdList"
                    :items="allQuotation"
                    item-text="Number"
                    item-value="Id"
                    small-chips
                    multiple
                    :loading-text="$t('common_get_data')"
                    :no-data-text="$t('common_no_results')"
                    :error-messages="errors[0]"
                    @click.native="getFilterQuotation"
                    :disabled="
                      editedMergeQuotation.Customer.Number === '' ||
                        !editedMergeQuotation.QuotationType ||
                        isAllTextFieldDisabled
                    "
                  >
                    <template v-slot:item="data">
                      <template>
                        <v-list-item-content>
                          <v-list-item-title>{{ data.item.Number }} </v-list-item-title>
                          <v-list-item-subtitle>
                            主旨:{{ data.item.Subject }}
                          </v-list-item-subtitle>
                          <v-list-item-subtitle
                            v-if="
                              data.item.Type === 1 || data.item.Type === 5 || data.item.Type === 8
                            "
                          >
                            車牌清單:
                            <div v-if="data.item.LicensePlateList.length > 5">
                              <v-chip v-for="index of 5" :key="index">
                                {{ data.item.LicensePlateList[index - 1] }}
                              </v-chip>
                              +({{ data.item.LicensePlateList.length - 5 }})
                            </div>
                            <div v-else-if="data.item.LicensePlateList.length > 0">
                              <v-chip
                                v-for="index of data.item.LicensePlateList.length"
                                :key="index"
                              >
                                {{ data.item.LicensePlateList[index - 1] }}
                              </v-chip>
                            </div>
                          </v-list-item-subtitle>
                          <v-list-item-subtitle
                            v-if="
                              data.item.Type === 2 ||
                                data.item.Type === 3 ||
                                data.item.Type === 4 ||
                                data.item.Type === 6 ||
                                data.item.Type === 7
                            "
                          >
                            車牌:{{ data.item.LicensePlate }}
                          </v-list-item-subtitle>
                          <v-list-item-subtitle v-if="data.item.Type === 3 || data.item.Type === 7">
                            沿用車牌:{{ data.item.OriginalLicensePlate }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </template>
                    </template>
                    <template v-slot:label>
                      <span class="red--text">
                        <strong>* </strong>
                      </span>
                      報價單清單
                    </template>
                  </v-autocomplete>
                </ValidationProvider>
              </v-col>
            </v-row>
          </ValidationObserver>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red"
            text
            @click="closeSelectMergeQuotation"
            :disabled="isAllTextFieldDisabled"
          >
            {{ $t('common_close') }}
          </v-btn>
          <v-btn
            color="green"
            text
            @click="exportMergeQuotation"
            :loading="isLoading"
            :disabled="editedMergeQuotation.QuotationIdList.length < 1"
          >
            匯出
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { HttpMergeQuotation, HttpQuotation } from '@/js/http-Manager'
import CustomerAutocomplete from '@/components/CustomerAutocomplete.vue'

export default {
  components: { CustomerAutocomplete },
  name: 'SelectMergeQuotation',
  data: () => ({
    isShowSelectMergeQuotation: false,
    editedMergeQuotation: {
      Customer: {
        Number: '',
        ShortName: '',
        Tel: '',
        Fax: '',
        Attribute: '',
        InvoiceAddress: '',
        CurrencyNo: '',
        InvoiceType: ''
      },
      QuotationType: 0,
      QuotationIdList: []
    },
    defaultMergeQuotation: {
      Customer: {
        Number: '',
        ShortName: '',
        Tel: '',
        Fax: '',
        Attribute: '',
        InvoiceAddress: '',
        CurrencyNo: '',
        InvoiceType: ''
      },
      QuotationType: 0,
      QuotationIdList: []
    },
    allQuotation: [],
    allQuotationType: [],
    isAllTextFieldDisabled: false,
    isLoading: false
  }),
  async mounted () {
    await this.getAllQuotationType()
  },
  watch: {},
  computed: {},
  methods: {
    isShowSelectMergeQuotationBtn () {
      this.isShowSelectMergeQuotation = true
    },
    async exportMergeQuotation () {
      const isValid = await this.$refs.mergeQuotation.validate()

      if (isValid) {
        this.isLoading = true
        this.isAllTextFieldDisabled = true
        let response = await HttpMergeQuotation.MergeQuotation(this.editedMergeQuotation)
        if (response && response.status === 200) {
          const blob = new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
          })
          const aEle = document.createElement('a') // 創建a標籤
          const href = window.URL.createObjectURL(blob) // 創建下載的鏈接
          aEle.href = href
          aEle.download =
            '合併_' +
            this.editedMergeQuotation.Customer.ShortName.slice(0, 4) +
            '_' +
            this.$moment(new Date()).format('YYYYMMDD_HHmmss') +
            '.xlsx' // 下載後文件名
          document.body.appendChild(aEle)
          aEle.click() // 點擊下載
          document.body.removeChild(aEle) // 下載完成移除元素
          window.URL.revokeObjectURL(href) // 釋放掉blob對象
        }
        this.isLoading = false
        this.isAllTextFieldDisabled = false
        this.closeSelectMergeQuotation()
      }
    },
    closeSelectMergeQuotation () {
      this.isShowSelectMergeQuotation = false
      this.$nextTick(() => {
        this.editedMergeQuotation = JSON.parse(JSON.stringify(this.defaultMergeQuotation))
        this.$emit('getAllQuotation')
      })
    },
    async setCustomer (val) {
      this.editedMergeQuotation.Customer = JSON.parse(JSON.stringify(val))
      await this.getFilterQuotation()
    },
    async getFilterQuotation () {
      let response = await HttpMergeQuotation.GetQuotationListForMergeQuotation({
        customerId: this.editedMergeQuotation.Customer.Id,
        quotationType: this.editedMergeQuotation.QuotationType
      })
      this.allQuotation = response && response.status === 200 ? response.data.Data : []
    },
    async getAllQuotationType () {
      let response = await HttpQuotation.GetAllQuotationTypes()
      if (response) {
        this.allQuotationType = response.status === 200 ? response.data.Data : []
      }
    }
  }
}
</script>
